import { Box, Skeleton } from '@mui/material';

export const renderSkeleton = () => (
  <Box>
    <Skeleton variant="text" width={200} height={30} />
    <Skeleton
      variant="rectangular"
      height={80}
      sx={{ borderRadius: 2, mt: 2 }}
    />
    <Box sx={styles.skeletonContent}>
      <Skeleton variant="circular" width={50} height={50} />
      <Skeleton variant="text" width="60%" />
    </Box>
    <Skeleton
      variant="rectangular"
      height={80}
      sx={{ borderRadius: 2, mt: 2 }}
    />
    <Skeleton
      variant="rectangular"
      height={80}
      sx={{ borderRadius: 2, mt: 2 }}
    />
    <Skeleton
      variant="rectangular"
      height={80}
      sx={{ borderRadius: 2, mt: 2 }}
    />
  </Box>
);

const styles = {
  skeletonContent: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    mt: 2,
  },
};
